export const EMPLOYEE_MANAGEMENT_PRIVILEGES = {
  userCreation: {
    access: [
      "systemSettings.employees.userCreation.management.create"
    ],
    create: "systemSettings.employees.userCreation.management.create"
  },
  roles: {
    access: [
      "systemSettings.employees.roleManagement.operations.create",
      "systemSettings.employees.roleManagement.operations.view",
      "systemSettings.employees.roleManagement.operations.edit",
      "systemSettings.employees.roleManagement.operations.clone",
      "systemSettings.employees.roleManagement.operations.delete"
    ],
    create: "systemSettings.employees.roleManagement.operations.create",
    view: "systemSettings.employees.roleManagement.operations.view",
    edit: "systemSettings.employees.roleManagement.operations.edit",
    clone: "systemSettings.employees.roleManagement.operations.clone",
    delete: "systemSettings.employees.roleManagement.operations.delete"
  },
  users: {
    access: [
      "systemSettings.employees.manageUsers.operations.export",
      "systemSettings.employees.manageUsers.operations.view",
      "systemSettings.employees.manageUsers.operations.edit",
      "systemSettings.employees.manageUsers.operations.resetPassword",
      "systemSettings.employees.manageUsers.operations.viewHierarchy",
      "systemSettings.employees.manageUsers.operations.delete"
    ],
    export: "systemSettings.employees.manageUsers.operations.export",
    view: "systemSettings.employees.manageUsers.operations.view",
    edit: "systemSettings.employees.manageUsers.operations.edit",
    resetPassword: "systemSettings.employees.manageUsers.operations.resetPassword",
    viewHierarchy: "systemSettings.employees.manageUsers.operations.viewHierarchy",
    delete: "systemSettings.employees.manageUsers.operations.delete"
  }
};

export const employeeManagementAccessPrivileges = [
  ...EMPLOYEE_MANAGEMENT_PRIVILEGES.userCreation.access,
  ...EMPLOYEE_MANAGEMENT_PRIVILEGES.roles.access,
  ...EMPLOYEE_MANAGEMENT_PRIVILEGES.users.access
];
